export const GET_ALL_BLOGS_REQUEST = "GET_ALL_BLOGS_REQUEST";
export const GET_ALL_BLOGS_SUCCESS = "GET_ALL_BLOGS_SUCCESS";
export const GET_ALL_BLOGS_FAIL = "GET_ALL_BLOGS_FAIL";

export const GET_BLOGS_DETAILS_REQUEST = "GET_BLOGS_DETAILS_REQUEST";
export const GET_BLOGS_DETAILS_SUCCESS = "GET_BLOGS_DETAILS_SUCCESS";
export const GET_BLOGS_DETAILS_FAIL = "GET_BLOGS_DETAILS_FAIL";

export const CLEAR_BLOGS_ERRORS = "CLEAR_BLOGS_ERRORS";
export const CLEAR_BLOGS_STATE = "CLEAR_BLOGS_STATE";
